import {toast} from "react-toastify";

const toastConfig = {
    position: toast.POSITION.BOTTOM_RIGHT,
    className: 'toastmsg'
};

export {toastConfig};